module.exports = {
	"actionUrl": "https://docs.google.com/forms/d/e/1FAIpQLSeXb2XTHu5lOjD12pOEnpltXzNbli4K7MF2KGJw5b3o02vh7w/formResponse",
	"fields": {
		"Player Name": "entry.1653896971",
		"Charity": "entry.1079188333"
	}
};


//////////////////
// WEBPACK FOOTER
// ./formDetails/players.json
// module id = 27
// module chunks = 0